import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import PullOutTray from './PulloutTray';

function App({variationItems}) {

  return (
    <div className="container">
      <div className="video-container">
        <iframe
          title="Embedded YouTube video"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/PmsjR4608do"
          frameBorder="0"
          allow="autoplay; encrypted-media"
        ></iframe>
      </div>
      <div className="right-side">
        <div id="main"></div>
      </div>
      <PullOutTray variationItems={variationItems} />
     
    </div>
  );
}

export default App;
